import moment from 'moment';

/**
 * Validates that an object has the following form: { name: string, id: number }
 * @param {Obj} obj An object to be validated. Must be the form { id: number, name: string }
 */
const commonValidator = (obj) => {
  if (!obj.hasOwnProperty('id') || typeof obj.id != 'number') {
    return false;
  }
  if (!obj.hasOwnProperty('name') || typeof obj.name != 'string') {
    return false;
  }
  return true;
};

const settingsProperties = [
  {
    prop: 'diets',
    validator: (value) => {
      if (Array.isArray(value) === false) {
        return false;
      }
      for (const val of value) {
        if (!commonValidator(val)) {
          return false;
        }
      }
      return true;
    },
  },
  {
    prop: 'event',
    validator: (obj) => commonValidator(obj),
  },
  {
    prop: 'office',
    validator: (obj) => commonValidator(obj),
  },
  {
    prop: 'date',
    validator: (value) => {
      // Omit this validation if it is running locally
      if (process.env.NODE_ENV === 'development') {
        return moment(value) && true;
      } else {
        const now = new Date();
        const expectedDate = new Date(value);
        const dayBeforeExpectedDate = new Date(value);
        dayBeforeExpectedDate.setDate(dayBeforeExpectedDate.getDate() - 1);

        const isToday = now.toDateString() === expectedDate.toDateString();
        const isYesterday = now.toDateString() === dayBeforeExpectedDate.toDateString();

        return isToday || isYesterday;
      }
    },
  },
];

/**
 * Validates settings obj based on the settingsProperties configuration
 * @param {Obj} settings
 */
const validateSettings = (settings) => {
  if (!settings) {
    throw new Error('Missing settings');
  }
  for (const { prop, validator } of settingsProperties) {
    if (!settings.hasOwnProperty(prop)) {
      throw new Error(`Missing ${prop} property`);
    } else {
      if (validator(settings[prop]) === false) {
        throw new Error(`Invalid value for ${prop} property`);
      }
    }
  }
  return true;
};

// eslint-disable-next-line import/prefer-default-export
export { validateSettings };



// WEBPACK FOOTER //
// ./store/modules/catering/helpers.js